import { Component, Input } from '@angular/core';
import { BasecasesViewModel } from '@store/scenario/basecases/basecases-slice';
import { MarketAreasViewModel } from '@store/scenario/market-areas/market-areas-slice';
import { RegionsViewModel } from '@store/scenario/regions/regions-slice';
import { SourcesViewModel } from '@store/scenario/sources/sources-slice';
import { SubtypesViewModel } from '@store/scenario/subtypes/subtypes-slice';
import { WeatherYearsViewModel } from '@store/scenario/weather-years/weather-years-slice';
import { SearchScenariosFormComponent } from '../search-scenarios-form/search-scenarios-form.component';

@Component({
  selector: 'app-search-scenarios-form-container',
  templateUrl: './search-scenarios-form-container.component.html',
  styleUrl: './search-scenarios-form-container.component.scss',
  imports: [SearchScenariosFormComponent],
})
export class SearchScenariosFormContainerComponent {
  @Input() regionsViewModel!: RegionsViewModel | null;
  @Input() sourcesViewModel!: SourcesViewModel | null;
  @Input() basecasesViewModel!: BasecasesViewModel | null;
  @Input() subtypesViewModel!: SubtypesViewModel | null;
  @Input() weatherYearsViewModel!: WeatherYearsViewModel | null;
  @Input() marketAreasViewModel!: MarketAreasViewModel | null;
}
